import styled from 'styled-components';

export const StyledObjectAnimation = styled.div`
    width: 0%;
    height: 0%;
`;